<template>
  <v-row>
    <!-- Selector de entidad -->
    <v-col cols="12" md="6">
      <v-select
        :value="entityType"
        @input="$emit('update:entity-type', $event)"
        :items="entityItems"
        item-text="ui.label"
        item-value="entity_type"
        label="Tipo de entidad"
        outlined
        dense
        :rules="[rules.required]"
      >
        <template v-slot:item="{ item }">
          <v-list-item-icon>
            <v-icon>{{ getEntityIcon(item.ui.icon) }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.ui.label }}</v-list-item-title>
            <v-list-item-subtitle>{{
              item.ui.description
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-select>
    </v-col>

    <!-- Selector de evento -->
    <v-col cols="12" md="6">
      <v-select
        :value="value"
        @input="handleEventChange"
        :items="eventItems"
        item-text="ui.label"
        item-value="event_action"
        label="Evento"
        outlined
        dense
        :rules="[rules.required]"
        :disabled="!entityType"
      >
        <template v-slot:item="{ item }">
          <v-list-item-icon>
            <v-icon>{{ getEventIcon(item.ui.icon) }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.ui.label }}</v-list-item-title>
            <v-list-item-subtitle>{{
              item.ui.description
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template v-slot:selection="{ item }">
          <v-chip small :color="getCategoryColor(item.ui.category)">
            <v-icon left small>{{ getEventIcon(item.ui.icon) }}</v-icon>
            {{ item.ui.label }}
          </v-chip>
        </template>
      </v-select>
    </v-col>

    <!-- Información del evento seleccionado -->
    <v-col cols="12" v-if="selectedEvent">
      <v-alert type="info" text dense outlined>
        <div class="font-weight-bold">{{ selectedEvent.ui.label }}</div>
        <div class="text-caption">{{ selectedEvent.ui.description }}</div>
        <div
          class="mt-2 text-caption"
          v-if="
            selectedEvent.available_fields &&
              selectedEvent.available_fields.length
          "
        >
          <strong>Campos disponibles:</strong>
          <v-chip
            v-for="field in selectedEvent.available_fields.slice(0, 10)"
            :key="field.key"
            x-small
            class="ml-1 mt-1"
          >
            {{ field.label }}
          </v-chip>
          <span v-if="selectedEvent.available_fields.length > 5" class="ml-1">
            +{{ selectedEvent.available_fields.length - 5 }} más
          </span>
        </div>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "WebhookEventSelector",
  props: {
    value: {
      type: String,
      default: ""
    },
    entityType: {
      type: String,
      default: "lead"
    },
    entities: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      rules: {
        required: v => !!v || "Este campo es requerido"
      }
    };
  },
  computed: {
    entityItems() {
      return this.entities;
    },
    selectedEntityConfig() {
      return this.entities.find(e => e.entity_type === this.entityType);
    },
    eventItems() {
      return this.selectedEntityConfig?.events || [];
    },
    selectedEvent() {
      if (!this.value || !this.eventItems.length) return null;
      return this.eventItems.find(e => e.event_action === this.value);
    }
  },
  methods: {
    handleEventChange(eventAction) {
      this.$emit("input", eventAction);
      const eventConfig = this.eventItems.find(
        e => e.event_action === eventAction
      );
      this.$emit("event-selected", eventConfig);
    },
    getEntityIcon(iconName) {
      const iconMap = {
        users: "mdi-account-multiple",
        user: "mdi-account",
        property: "mdi-home",
        default: "mdi-database"
      };
      return iconMap[iconName] || iconMap.default;
    },
    getEventIcon(iconName) {
      const iconMap = {
        "plus-circle": "mdi-plus-circle",
        edit: "mdi-pencil",
        trash: "mdi-delete",
        funnel: "mdi-filter-variant",
        "check-circle": "mdi-check-circle",
        "x-circle": "mdi-close-circle",
        trophy: "mdi-trophy",
        default: "mdi-lightning-bolt"
      };
      return iconMap[iconName] || iconMap.default;
    },
    getCategoryColor(category) {
      const colorMap = {
        lifecycle: "blue",
        //phase: "primary",
        conversion: "green",
        default: "grey"
      };
      return colorMap[category] || colorMap.default;
    }
  }
};
</script>
